<app-group-calendar-grid
  [monthData]="monthData"
  [locationOptions]="locationOptions"
  [settings]="settings"
  [groups]="groups"
  [showGroupColumn]="showGroupColumn"
  [isLoading]="isLoading"
  [monthLabel]="monthLabel"
  [viewYear]="viewYear"
  [templateStats]="templateStats"
  [statsLocationColumns]="statsLocationColumns"
  [showSettingsButton]="true"
  (prevMonthClicked)="prevMonth()"
  (nextMonthClicked)="nextMonth()"
  (settingsClicked)="openSettings()"
  (cellClicked)="onCellClickFromGrid($event)"
  (eventDropped)="onEventDroppedFromGrid($event)"
  (chipClicked)="onChipClickFromGrid($event)"
  (groupChanged)="onGroupChange($event.row, $event.value)">
</app-group-calendar-grid>
